import { useState, useEffect } from "react";
import DeviceOrientation, { Orientation } from "react-screen-orientation";

import Base from "components/Landscape/screens/Base";
import Portrait from "components/Portrait";
import { Redirect } from "react-router-dom";

function LandscapeBase() {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  const [audioContextInstance, setAudioContextInstance] = useState(
    new AudioContext()
  );
  const [isLandscape, setIsLandscape] = useState(
    window.innerHeight < window.innerWidth
  );

  useEffect(() => {
    const handleResize = () => {
      setIsLandscape(window.innerHeight < window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isLandscape ? (
    <Base audioContextInstance={audioContextInstance} />
  ) : (
    <Redirect to="/por" />
  );

  // <DeviceOrientation lockOrientation={"landscape"}>
  //   {/* Will only be in DOM in landscape */}
  //   <Orientation orientation="landscape" alwaysRender={false}>
  //     <Base audioContextInstance ={audioContextInstance} />
  //   </Orientation>
  //   {/* Will stay in DOM, but is only visible in portrait */}
  //   <Orientation orientation="portrait" alwaysRender={false}>
  //     <Redirect to='/por' />
  //   </Orientation>
  // </DeviceOrientation>
}

export default LandscapeBase;
